import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryMetricsRangeArgs, SpaceliftMetrics } from "types/generated";

type GetTimeToRecoveryAverageData = {
  metricsRange: Pick<SpaceliftMetrics, "averageTimeToRecoveryValue">;
};

export const GET_TIME_TO_RECOVERY_AVERAGE: TypedDocumentNode<
  GetTimeToRecoveryAverageData,
  QueryMetricsRangeArgs
> = gql`
  query GetTimeToRecoveryAverage($input: MetricsInput) {
    metricsRange(input: $input) {
      averageTimeToRecoveryValue {
        value
      }
    }
  }
`;
